import Sharer from './modules/share/sharer';
import AutoResizeVideos from './modules/videos/autoresize';
import ContentModuleGallery from './modules/galleries/cm-gallery';
import Hero from './modules/hero/hero';
import TestimonialsCarousels from './modules/carousels/testimonials';
import VacancyFilters from './modules/vacancies/filters';
import 'picturefill';
import AOS from 'aos';

// Picture element HTML5 shiv
document.createElement("picture");

AOS.init({
    duration: 750
});
document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.faq-item');
    console.log("test", faqItems)
    faqItems.forEach(function (item) {
        const trigger = item.querySelector('.faq-item__heading');
        const panel = item.querySelector('.faq-item__desc');
        console.log("test", trigger, panel)
        if (!trigger || !panel) return;

        trigger.addEventListener('click', function () {
            const isOpen = item.classList.contains('is-open');
            console.log("test", isOpen)
            // close all
            faqItems.forEach(function (otherItem) {
                otherItem.classList.remove('is-open');
            });

            // open current if it was closed
            if (!isOpen) {
                item.classList.add('is-open');
            }
        });
    });
});